export const sortByDateDesc = <T>(key: keyof T) =>
  (a: T, b: T): number =>
    new Date(b[key] as unknown as string).getTime() -
    new Date(a[key] as unknown as string).getTime();
